export default __webpack_public_path__ + "static/media/c3d1a14eef7b8a7e.38c6f8cc31fc1eea470b6ef511d0cda7.svg";